import { Routes, Route } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

// Route condivise parte pubblica / area riservata: i visitatori anonimi vedono la
// pagina pubblica SEO; gli utenti autenticati vedono la pagina applicativa esistente.
// Nessuna modifica a menu, permessi o route private.
export default function PublicOrPrivate({ pub, priv }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="public-route-loading">
        <Loader2 className="w-5 h-5 animate-spin text-slate-500" aria-hidden="true" />
      </div>
    );
  }
  if (!user) return pub;
  return (
    <Routes>
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="*" element={priv} />
      </Route>
    </Routes>
  );
}
